import { SelectorOption } from "../../../../components/Redux/BasicSelector";

export const CodecClientOptions: SelectorOption[] = [
  {
    label: "Choose Codec Client Type",
    id: "",
  },
  {
    label: "HTTP1",
    id: "http1",
  },
  {
    label: "HTTP2",
    id: "http2",
  },
];
